/**
 * Platform Fees Configuration
 * ============================
 * 
 * Константы комиссий платформ и утилиты для расчета чистого дохода
 */

/**
 * Комиссии платформ (сколько забирают)
 */
export const PLATFORM_FEES = {
  android: 0.31,  // Google берет 31%
  ios: 0.31,      // Apple берет 31%
};

/**
 * Чистые коэффициенты (сколько получаем мы)
 */
export const PLATFORM_NET_RATES = {
  android: 0.69,  // Мы получаем 69%
  ios: 0.69,      // Мы получаем 69%
};

/**
 * Применяет коэффициент платформы к revenue
 * 
 * @param {number} revenue - Исходный доход
 * @param {string} platform - Платформа ('android' | 'ios' | другое)
 * @returns {number} - Доход с учетом комиссии платформы
 */
export const applyPlatformFee = (revenue, platform) => {
  if (!revenue || !platform) {
    return revenue || 0;
  }
  
  const platformLower = platform.toLowerCase();
  
  // Для 'all' используем единый коэффициент
  if (platformLower === 'all') {
    return revenue * 0.69; // 69% для обеих платформ
  }
  
  const rate = PLATFORM_NET_RATES[platformLower];
  
  // Если платформа неизвестна, возвращаем как есть
  if (!rate) {
    return revenue;
  }
  
  return revenue * rate;
};

/**
 * Получает процент чистого дохода для платформы
 * 
 * @param {string} platform - Платформа
 * @returns {number} - Процент (70 или 67)
 */
export const getPlatformNetPercentage = (platform) => {
  const rate = PLATFORM_NET_RATES[platform?.toLowerCase()];
  return rate ? Math.round(rate * 100) : 100;
};

/**
 * Получает текстовое описание комиссии
 * 
 * @param {string} platform - Платформа
 * @returns {string} - Описание, например "70% net"
 */
export const getPlatformFeeLabel = (platform) => {
  const percentage = getPlatformNetPercentage(platform);
  return percentage < 100 ? `${percentage}% net` : '';
};
